import React, {useEffect, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";
import CancelButton from "../../../../../../components/buttons/CancelButton";
import FormFieldText from "../../../../../../components/FormFieldText";
import SaveButton from "../../../../../../components/buttons/SaveButton";
import {VisitRequestDto} from "../../../../../../modules/vms/dto/VisitRequestDto";
import {VisitRequestApi} from "../../../../../../modules/vms/api/VisitRequestApi";
import {HttpStatus} from "../../../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../../../utils/MessageUtils";
import {UserDto} from "../../../../../../modules/account/dto/UserDto";
import {DepartmentUserDto} from "../../../../../../modules/vms/api/DepartmentUserDto";
import SearchIconButton from "../../../../../../components/buttons/SearchIconButton";
import FormFieldSelect from "../../../../../../components/FormFieldSelect";

export type Host2ndDialogProps = {
    onClose: () => void;
    onOk: () => void;
    open: boolean;
    visitRequest?: VisitRequestDto
};

const Host2ndDialog: React.FC<Host2ndDialogProps> = (props) => {
    const intl = useIntl();

    const [hostName2, setHostName2] = useState('');
    const [hostDepartmentName2, setHostDepartmentName2] = useState('');
    const [hostDepartmentId2, setHostDepartmentId2] = useState('');
    const [searchHostName, setSearchHostName] = useState("");
    // 部门+人员
    const [departmentList, setDepartmentList] = useState<Array<DepartmentUserDto>>([]);

    useEffect(() => {
        if (props.open) {
            let hostName2 = "";
            let hostDepartmentName2 = "";
            let hostDepartmentId2 = "";
            let host2Json;
            if (props.visitRequest && props.visitRequest.remarks) {
                host2Json = JSON.parse(props.visitRequest.remarks);
                if (host2Json) {
                    hostName2 = host2Json.hostName2;
                    hostDepartmentName2 = host2Json.hostDepartmentName2;
                    hostDepartmentId2 = host2Json.hostDepartmentId2;
                }
            }
            setHostName2(hostName2);
            setHostDepartmentName2(hostDepartmentName2);
            setHostDepartmentId2(hostDepartmentId2);

        }
    }, [props.open]);

    const handleOk = async () => {
        if (props.visitRequest) {
            const remarksJson = {
                hostName2: hostName2,
                hostDepartmentName2: hostDepartmentName2,
                hostDepartmentId2: hostDepartmentId2

            };
            const responseResult = await VisitRequestApi.updateRequestRemarks(props.visitRequest.id, JSON.stringify(remarksJson));
            if (responseResult.status === HttpStatus.SUCCESS) {
                MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_UPDATE_SUCCESS'}));
                props.onClose();
                props.onOk();
            }
        }
    };

    const handleCancel = () => {
        props.onClose();
    }
    const _handleCheckEmployeeByName = async (hostName: string) => {
        if (hostName) {
            const responseResult = await VisitRequestApi.searchEmployeeByName(hostName);
            if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
                let resultData = responseResult.data;
                if (resultData) {
                    if (resultData.length > 0) {
                        let userList = Object.assign(new Array<UserDto>(), resultData);
                        const departList = new Array<DepartmentUserDto>();
                        userList.forEach((item: UserDto) => {
                            let department = item.department;
                            if (department) {
                                let departmentUserDto = new DepartmentUserDto(department, item);
                                departList.push(departmentUserDto)
                            }
                        })
                        setDepartmentList(departList);
                        if (departList.length == 1) {
                            const item = departList[0];
                            setHostDepartmentName2(item.name);
                            setHostDepartmentId2(item.id);

                        }
                    } else {
                        MessageUtils.warning(intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NOT_FOUND"}));

                    }
                } else {
                    MessageUtils.warning(intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NOT_FOUND"}));
                }
            }
        }
    }
    const _handleChange = (name: string, value: any) => {
        if (name === 'departmentId') {

            setHostDepartmentId2(value.id);
            setHostDepartmentName2(value.name);


        }

    };
    return (
        <Dialog open={props.open} onClose={handleCancel} fullWidth={true}>
            <DialogTitle>
                <FormattedMessage id={'VMS_VISIT_REQUEST_HOST_2ND'}/>
            </DialogTitle>
            <DialogContent>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME_2ND"})}
                               required={true}
                               value={hostName2}
                               onChange={(value) => setHostName2(value)}
                               endAdornment={
                                   <div>
                                       <SearchIconButton
                                           onClick={() => _handleCheckEmployeeByName(hostName2)}/>
                                   </div>
                               }
                />
                <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_DEPARTMENT_2ND"})}
                                 required={true}
                                 value={hostDepartmentId2}
                                 onChange={(value) => {
                                     let filter = departmentList.filter(item => item.id === value);
                                     if (filter.length > 0) {
                                         _handleChange("departmentId", filter[0]);
                                     }
                                 }}
                                 items={departmentList.map((item) => {
                                     return {label: item.name + " " + item.userName, value: item.id}
                                 })}/>

                {/*<FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME_2ND"})}*/}
                {/*               value={hostName2}*/}
                {/*               onChange={(value) => {*/}
                {/*                   setHostName2(value)*/}
                {/*               }}/>*/}
                {/*<FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_MOBILE_2ND"})}*/}
                {/*               value={hostMobile2}*/}
                {/*               onChange={(value) => {*/}
                {/*                   setHostMobile2(value)*/}
                {/*               }}/>*/}
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleCancel}/>
                <SaveButton onClick={handleOk}/>
            </DialogActions>
        </Dialog>
    );
};

export default Host2ndDialog;